import React from 'react';
import { motion } from 'framer-motion';
import './Automobile.css';

const Automobile: React.FC = () => {
  return (
    <div className="venture-page">
      <div className="venture-container">
        {/* Main Content */}
        <div className="venture-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="venture-main-section"
          >
            <div className="venture-header">
              <div className="venture-header-background"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/automobile.jpg)` }}
              >
                <div className="venture-header-overlay">
                  <h2 className="section-main-title">Automobile</h2>
                </div>
              </div>
            </div>

            
            <div className="venture-content-container">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="venture-text-section"
              >
                <div className="venture-text-content">
                  <div className="venture-text">
                    
                    <p>
                     Ansuvara Group has long been recognized as a pioneer in the automobile sector in Pokhara. The
                    journey began in 1993 with the rental of motorbikes and evolved into one of the region’s most
                    trusted automotive enterprises. Over the years, the Group proudly held dealership rights for a diverse
                    range of global vehicle brands including Daewoo Matiz, Chevrolet, Proton, Ssangyong, Opel, Zotye,
                    Daihatsu, Ford, and Peugeot.
                    </p>
                    <p>
                     As one of the oldest and most reputable automobile traders in the region, Ansuvara’s success in the
                    sector was built on its unwavering commitment to the 3S principle: aggressive in Sales, humble in
                    Service, and genuine in Spare Parts.
                    </p>
                    <p>
                     While Ansuvara Group has since transitioned out of the automobile business, its legacy in the sector
                    remains a testament to the Group’s ability to identify opportunities, deliver value, and build trust over
                    time.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>


          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Automobile;
